import en from '../content/en.json';
import de from '../content/de.json';


export const dictionary = { de, en };
export const languages = ['de', 'en'];

export const changeLanguage = (lang) => {
	if (lang && languages.indexOf(lang) >= 0) {
    document.userLang = lang;
    return true;
	}
	return false;
};

export const getLanguage = () => {
	if (document.userLang) return document.userLang;

	let lang = null;

	if (document.location.search) {
		let langQuery = document.location.search.match(/lang=(\w+)/i);
		if (langQuery && langQuery[1] ) {
			lang = langQuery[1].toLowerCase();
			if (languages.indexOf(lang) < 0) {
				lang = null;
			}
		}
	}

	if (!lang) {
		lang = (window.navigator.userLanguage || window.navigator.language).replace(/(\w+)([-_](\w+))?/gi, '$1');
	}

	if (lang && languages.indexOf(lang) >= 0) {
		document.userLang = lang;
		return lang;
	}

	return 'en';
};

export const t = (key, inserts) => {
	const lang = getLanguage();
	let text = (dictionary[lang] && dictionary[lang][key]) || `[${key}]`
	if (inserts) {
		text = text.replace(/\$(\w+)/g, (match, id) => inserts[id] || match);
	}
	return text;
};
